module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8BAMAAADI0sRBAAAAFVBMVEVHcEz/iBL6gQr6gAv6gAr6gAr6gAqW66y0AAAAB3RSTlMAHKbm/+2nMPnTbQAAAE1JREFUeAFjIBuMAkZlFxAwEkBmIoCoCwQEIjMRIAUq5oTMRAATqJgzMhMBXGAAiYlDelSacKASjhLCEcqYDEsDCOYwT6mjKXU0pY4CAF0upynPNQ7eAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tabbar-icon/tabbar_sort_sel@2x.png
// module id = ChuB
// module chunks = 0